import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CreateMediaLogLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CreateMediaLog' */ './components/CreateMediaLog'
		)
);

export default (store) => {
	return {
		path: 'home/media-log/create',
		element: <AsyncLoading component={<CreateMediaLogLazy />} />,
	};
};
